import React from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';

import { transformToSEOLinks } from './transformToSEOLinks';
import type { CommonNavContent } from 'client-site-chrome-ui/content/types/commonNavigation';

interface SEOLinksProps {
  content: CommonNavContent;
}

export const SEOLinks = ({ content }: SEOLinksProps) => {
  const links = transformToSEOLinks(content);

  return (
    <div css={visuallyHidden}>
      {links.map((link, index) => {
        return (
          <a href={link.url} key={index}>
            {link.title}
          </a>
        );
      })}
    </div>
  );
};
